export const FEATURE_NAME = '@zerops/zerops/core/billing-base';
